module.exports = __webpack_public_path__ + "img/scared.be5030ca.webp";